export const RQ_GET_FIELD_STRUCTURE_API = {
  url: 'report/field-structure?divisionId=<%= divisionId %>',
  method: 'GET',
  auth: true,
};
